import {useOperation} from "../use-operation.hook";
import {UserView} from "../interfaces/user-view.interface";

export default function useCurrentUser() {
    return useOperation<UserView>('getCurrentUser')
}